import React from "react";
import AdminNewsActions from "../../Components/Admin/AdminNewsActions";
import SideBar from "../../Components/Admin/SideBar";

const AdminNewsActionsPage = ()=>{
    return (
      <AdminNewsActions />
    )
}

export default AdminNewsActionsPage;